import React from 'react';
import { business, serviceArea } from '../../data/site';
export function AreaSection() {
  return <section aria-labelledby="area-title" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-28" data-id="element-64" data-mp="5fd51g3t7xxf">
      <div className="grid gap-12 lg:grid-cols-12" data-id="element-65" data-mp="o3gyjxwt2nn">
        <div className="lg:col-span-5" data-id="element-66" data-mp="mshgwbhyh2c">
          <h2 id="area-title" className="font-serif text-4xl font-medium leading-tight text-forest md:text-5xl" data-id="element-67" data-mp="3rvzjkpnnimmc">
            Un jardinier près de chez vous
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-ink-muted" data-id="element-68" data-mp="3hx086zbi4cvn">
            Basé à {business.city}, j’interviens dans les communes voisines. Votre ville n’apparaît
            pas ? Demandez quand même : la liste n’est pas fermée.
          </p>
        </div>
        <ul className="flex flex-wrap content-start gap-x-8 gap-y-4 lg:col-span-7 lg:pt-3" data-id="element-69" data-mp="38y6f3ixdq4mu">
          {serviceArea.map((town, index) => <li key={town} className={`font-serif text-2xl md:text-3xl ${index === 0 ? 'text-clay' : 'text-ink'}`} data-id="element-70" data-mp="1758kpinyf3zs" data-mpi={index}>
              {town}
            </li>)}
        </ul>
      </div>
    </section>;
}